import React, { Component } from 'react';
import { connect } from 'dva';
import { Spin, Alert } from 'antd';
import Container from '@/components/Container';
import styles from './index.less';

@connect(({ departmentType, loading }) => {
  return {
    loading: loading.effects['departmentType/fetchList'] || false,
    data: departmentType.data,
    spinProps: departmentType.spinProps,
  };
})
class DepartmentType extends Component {
  constructor(props) {
    super(props);
  }

  // 渲染推荐名字列表
  renderRecommendDeptName = ({ recommendDeptNameList = [] }) => {
    const text = recommendDeptNameList.map(({ recommendName }) => recommendName).join('、');
    return (
      <div className="department-line recomend-name">
        <div className="dept-Type-label">推荐部门:</div>
        <div className="dept-Type-Name">{text}</div>
      </div>
    );
  };

  // 渲染部门类型
  renderDeparmentList = data => {
    return (
      <div className="departmentList">
        {(data || []).map(
          ({ deptTypeName = '', deptTypeSign = '', recommendDeptNameList = [] }) => {
            return (
              <div className="department-item" key={deptTypeSign}>
                <div className="department-line">
                  <div className="dept-Type-label">部门类型:</div>
                  <div className="dept-Type-Name">{deptTypeName}</div>
                </div>
                {recommendDeptNameList && this.renderRecommendDeptName({ recommendDeptNameList })}
              </div>
            );
          }
        )}
      </div>
    );
  };

  render() {
    const { data, spinProps } = this.props;

    return (
      <Container breStates={!0} version={2}>
        <div className={styles.root}>
          <Spin {...spinProps}>
            <Alert
              type="info"
              description="系统为您设置了部门类型，提示： 部门类型 列如： 党支部
            是与岗位进行相绑定，您进行名称修改时，需谨慎操作。如有疑问，请联系客服。 特别提示
            推荐部门名称可进行哦～"
              message="使用说明"
            />
            {this.renderDeparmentList(data)}
          </Spin>
        </div>
      </Container>
    );
  }
}

export default DepartmentType;
